<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="400px"
    top="32vh"
    center
    :destroy-on-close="true"
  >
    <div>
      <el-row type="flex" justify="center" class="excelBtn">
        <el-col :span="8" class="font-blod">下载excel模版</el-col>
        <el-col :span="8">
          <el-button type="primary" @click="downloadTemplate">
            <div class="btnclass">
              <img src="../../../assets/download.png" alt="" />
              <span>excel模版下载</span>
            </div>
          </el-button>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" class="excelBtn">
        <el-col :span="8" class="font-blod">导入excel</el-col>
        <el-col :span="8">
          <file-upload
            ref="fileUploadRef"
            @addUpload="handleFileUpload"
            :title="uploadTitle"
            :limit="1"
          />
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="tableBtn">
      <div @click="cancelUpload">取消</div>
      <div @click="submitUpload" :class="{ disabled: loading }">
        <span v-if="submitLoading">导入中...</span>
        <span v-else>确认导入</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import FileUpload from "@/components/Upload/fileUpload";

export default {
  components: {
    FileUpload,
  },
  props: {
    downloadTemplateUrl: String,//下载模板地址
    importUrl: String,//上传文件地址
    title: String,//弹窗标题
    uploadTitle: String, //导入按钮标题
    errUrl:String,//下载错误导入文件
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      upLoadData: "",
      key: "",
      submitLoading: false,
    };
  },
  methods: {
    openDialog() {
      this.upLoadData = "";
      this.dialogVisible = true;
      this.$nextTick(() => {
      if (this.$refs.fileUploadRef ) {
        this.$refs.fileUploadRef.$refs.upload.clearFiles();
      }
    });
    },
    //下载导入模板
    downloadTemplate() {
      this.global
        .exportExcel(this.downloadTemplateUrl, {}, this.title)
        .catch((res) => {
          this.handleError(res);
        });
    },
    handleFileUpload(item) {
      this.loading = true;
      this.upLoadData = item;
    },
    //调用上传方法
    submitUpload() {
      if (!this.global.handleEmptyData(this.upLoadData)) {
        this.submitLoading = true;
        let formData = new FormData();
        formData.append("file", this.upLoadData.file);
        this.HttpService.post(this.importUrl, formData).then((res) => {
          if (res.statusCode !== 200) {
            this.$message.error(res.message);
          } else {
            if (res.data) {
              this.errorTips(res.data);
              return;
            }
            this.$message.success("导入成功");
            this.key = res.data;
            this.$emit("opera-success");
            this.submitLoading = false;
          }
          this.cancelUpload();
        });
      } else {
        this.$message.error("请上传文件");
        this.submitLoading = false;
      }
    },
    cancelUpload() {
      if (this.$refs.fileUploadRef ) {
        this.$refs.fileUploadRef.$refs.upload.clearFiles();
      }
      this.upLoadData = {};
      this.dialogVisible = false;
    },
    handleError(res) {
      let blob = new Blob([res.response.data], { type: "application/json" });
      var blobReader = new Response(blob).json();
      blobReader.then((res) => {
        this.$message.error(res.message);
      });
    },
    //提示导出报错
    errorTips(errorId) {
      let _this = this;
      this.$confirm(
        "导入失败，请点击下载结果并检查失败原因，修改后重新导入",
        "导入结果",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        }
      )
        .then(() => {
          _this.downloadErrorFun(errorId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //下载导入结果
    downloadErrorFun(downLoadId) {
      let title = "导入结果下载";
      this.global.exportExcel(this.errUrl+'/'+downLoadId, {}, title).catch((res) => {
        let blob = new Blob([res.response.data], {
          type: "application/json",
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.excelBtn {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.btnclass {
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/commonBath.vue